import { Reason } from '../implementation';
export class TimeoutReason extends Reason {
    static discard(reason) {
        if (!(reason instanceof TimeoutReason)) {
            throw reason;
        }
    }
    constructor(message = 'Timeout reached') {
        super(message, 'TIMEOUT');
    }
}
//# sourceMappingURL=timeout-reason.js.map